import AsyncSwitch from './AsyncSwitch';

export default AsyncSwitch;
